<template>
  <live-hub-form
    :live-hub-id="liveHubName"
    details
    @submit="updateLiveHub"
    @close="onClose"
  />
</template>
<script>
import LiveHubForm from '../Form.vue'

export default {
  name: 'EditLiveHub',
  components: {
    LiveHubForm,
  },
  data() {
    return {
      liveHubName: null,
    }
  },
  created() {
    this.liveHubName = this.$route.params.liveHubName
  },
  methods: {
    updateLiveHub(liveHub) {
      const query = {
        liveHubName: this.liveHubName,
        liveHub: {
          jobTemplateId: liveHub.jobTemplateId,
          destination: liveHub.destination,
          description: liveHub.description,
          bucket: liveHub.bucket,
          record: liveHub.record,
          input: liveHub.input,
          tags: liveHub.tags,
        },
      }
      this.$store
        .dispatch('liveHubs/modifyLiveHub', query)
        .then(res => {
          this.successToast('Live Hub was updated')
          this.onSuccess(res)
        })
        .catch(error => {
          this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while updating live hub.')
        })
    },
    onSuccess(response) {
      const { name } = response.data.result
      this.$router.push({ name: 'live-hub-settings', params: { liveHubName: name } })
    },
    onClose() {
      this.$router.push({
        name: 'live-hubs',
      })
    },
  },
}
</script>
